import React, {useEffect, useRef, useState} from 'react';
import {motion, useInView} from 'framer-motion';

import SecurityCard from './SecurityCard';

import {useMediaQuery} from '../../hooks/useMediaQuery';
import styles from './styles/main-09.module.css';

import {ReactComponent as CloudImg} from '../../assets/main09/cloud.svg'
import {ReactComponent as CloudLargeImg} from '../../assets/main09/cloud-lg.svg';
import {ReactComponent as OnPremiseImg} from '../../assets/main09/on-premise.svg'
import {ReactComponent as OnPremiseLargeImg} from '../../assets/main09/on-premise-lg.svg';
import {ReactComponent as UnLockImg} from '../../assets/main09/unlock.svg'
import {ReactComponent as UnLockLargeImg} from '../../assets/main09/unlock-lg.svg';

const easeInMotion = {
    ease: 'easeIn',
    duration: 0.6
};

const cardMotion = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 20
      }
    }
};

export default function Main09() {
    const mobile = useMediaQuery('(max-width: 768px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');
    const mobileLarge = useMediaQuery('(min-width: 769px) and (max-width: 1024px)');

    const ref = useRef(null);
   
    const isInView = useInView(ref, {
        once: true,
        amount: mobileMedium ? 0.1 : 0.2,
        margin: mobileMedium ? '-20px 0px' : '-100px 0px'
    });

    const [step, setStep] = useState(0);

    useEffect(() => {
        if(isInView) {
            const timer1 = setTimeout(() => setStep(1), 0);
            const timer2 = setTimeout(() => setStep(2), 400);
            const timer3 = setTimeout(() => setStep(3), 900);
            const timer4 = setTimeout(() => setStep(4), 1400);

            return () => {
                [timer1, timer2, timer3, timer4].forEach(clearTimeout);
            };
        }
    }, [isInView]);

  return (
    <div className={styles.wrapper} ref={ref}>
        <div className={styles.container}>
            <motion.p
                initial={{ opacity: 0 }}
                animate={step >= 1 ? { opacity: 1 } : { opacity: 0 }}
                transition={easeInMotion}
            >
                기업 내부 정보<br />
                유출이 걱정되시나요?
            </motion.p>
            <div className={styles.boxCard}>
                <motion.div
                    initial='hidden'
                    animate={step >= 2 ? 'visible' : 'hidden'}
                    variants={cardMotion}
                >
                    <SecurityCard
                        text='Private Cloud 환경 이용'
                        Image={mobileLarge ? CloudLargeImg : CloudImg}
                    />
                </motion.div>
                
                <motion.div
                    initial='hidden'
                    animate={step >= 3 ? 'visible' : 'hidden'}
                    variants={cardMotion}
                >
                    <SecurityCard
                        text='온 프레미스 구축 가능'
                        Image={mobileLarge ? OnPremiseLargeImg : OnPremiseImg}
                    />
                </motion.div>

                <motion.div
                    initial='hidden'
                    animate={step >= 4 ? 'visible' : 'hidden'}
                    variants={cardMotion}
                >
                    <SecurityCard
                        text={mobile ? <>내부 부서, 직급별<br /> 데이터 접근 권한 설정 가능</> : <>내부 부서, 직급별 데이터 접근 권한 설정 가능</>}
                        Image={mobileLarge ? UnLockLargeImg : UnLockImg}
                    />
                </motion.div>
            </div>
        </div>
    </div>
  );
}
